import { toast } from "sonner";

// useShare.js
interface ShareOptions {
  title: string;
  text: string;
  url: string;
}
export const useShare = () => {
  const share = async ({ title, text, url }: ShareOptions) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url,
        });
        toast.success("¡Enlace compartido exitosamente!");
      } catch (error) {
        toast.error("Error al compartir");
        console.log("Error al compartir:", error);
      }
    } else {
      toast.error("La función de compartir no está disponible en este navegador");
    }
  };

  return { share };
};
